module.exports = __webpack_public_path__ + "img/previous-month-triangle.7d32b11d.svg";